import { useNavigate, useLocation } from 'react-router-dom';
import feathersClient from '../../apiClient';
import { useQueryClient } from 'react-query';
import { useUser } from '../../apiClient/ApiContext';

export default function UserPanel() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const user = useUser();

  const logoutUser = async () => {
    await feathersClient.logout();
    navigate(`/signin`, { state: { redirect: location.pathname+location.search } });

    queryClient.removeQueries('reAuthenticate', { exact: true });
    await queryClient.invalidateQueries(['reAuthenticate']);
  };

  return (
    <div className="flex items-center gap-4 pl-10 pb-8 pt-4" onClick={logoutUser}>
      <div className="rounded-full size-10 text-center content-center uppercase bg-white">{user?.person?.first_name[0]}{user?.person?.last_name[0]}</div>
      <div className="flex flex-col">
        <div className="text-body-2-xl text-secondary-500 font-semibold">{user?.person?.first_name} {user?.person?.last_name}</div>
        <div className="text-caption-xl text-secondary-400">{user?.role?.[0].name}</div>
      </div>
    </div>
  )
}
